import { useState, useEffect } from 'react';
import { theme } from '../tailwind.config';

const screens = Object.fromEntries(
  Object.entries(theme.screens).map(([key, value]) => [
    key,
    Number(value.replace('px', '')),
  ])
);

export enum Screen {
  mobile = screens.mobile,
  tablet = screens.tablet,
  desktop = screens.desktop,
}

export default function useScreen(): { screen: Screen | null } {
  const [screen, setScreen] = useState<Screen | null>(null);

  useEffect(() => {
    const handleWindowResize = () => {
      const width = window.innerWidth;
      if (width <= Screen.mobile) {
        setScreen(Screen.mobile);
      } else if (width <= Screen.tablet) {
        setScreen(Screen.tablet);
      } else {
        setScreen(Screen.desktop);
      }
    };

    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return { screen };
}
